import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import { approveEmployeeEdit } from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import Issue from './Issue';

const EmployeeEdit = ({ issue, shift, onClick }) => {
  const handleClick = useCallback(
    () =>
      onClick({
        shiftId: shift.get('id'),
        originPath: window.location.pathname,
      }),
    [onClick, shift]
  );

  return <Issue issue={issue} onClick={handleClick} />;
};

export default connect(() => ({}), {
  onClick: approveEmployeeEdit,
})(EmployeeEdit);
